import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { TimeSheetProjectService } from "src/app/services/time-sheet-project.service";
import { Config } from "src/app/utility/config";
import Swal from "sweetalert2";

@Component({
  selector: "app-time-sheet-projects",
  templateUrl: "./time-sheet-projects.component.html",
  styleUrls: ["./time-sheet-projects.component.scss"],
})
export class TimeSheetProjectsComponent implements OnInit {
  displayedColumns: string[] = ["Project_Name", "Actions"];
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  ModalOpen: boolean;
  timeSheetProject: any;
  constructor(
    private formBuilder: FormBuilder,
    private api: TimeSheetProjectService,
    private config: Config
  ) {
    this.timeSheetProject = this.formBuilder.group({
      project_Id: 0,
      project_Name: "",
      status: "",
      start_Date: "",
      end_Date: "",
    });
  }

  ngOnInit() {
    this.GetProject();
  }

  openModel() {
    this.ModalOpen = true;
  }
  cancel() {
    this.ModalOpen = false;
  }
  saveProject() {
    console.log(" this.timeSheetProject ", this.timeSheetProject.value);
    this.config.startLoader();
    this.timeSheetProject.value.start_Date = this.config.getCurrentDate();
    this.timeSheetProject.value.end_Date = this.config.getCurrentDate();
    this.timeSheetProject.value.Status = "Pending";
    this.api.saveProject(this.timeSheetProject.value).subscribe((res) => {
      if (res.status === "1") {
        this.config.ToastrSuccess(res.message);
        this.ModalOpen = false;
        this.config.stopLoader();
        this.GetProject();
      } else {
        this.config.ToastrError(res.message);
      }
    });
  }

  GetProject() {
    this.config.startLoader();
    this.api.getAllProjects().subscribe((res) => {
      console.log(res);

      if (res.status === "1") {
        this.dataSource = new MatTableDataSource(res.result);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.config.stopLoader();
      }
    });
  }

  // Search
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }
  getById(id) {
    this.config.startLoader();
    this.ModalOpen = true;
    this.api.GetProjectsById(id).subscribe((res) => {
      console.log("getById", res);

      if (res.status === "1") {
        this.timeSheetProject.patchValue({
          project_Id: res.result.project_Id,
          project_Name: res.result.project_Name,
          status: res.result.status,
          start_Date: res.result.start_Date,
          end_Date: res.result.end_Date,
        });
        this.config.stopLoader();
        this.GetProject();
      } else {
        this.config.ToastrError(res.message);
      }
    });
  }
  delete(id) {
    Swal.fire({
      title: "Are you sure want to delete?",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        this.config.startLoader();
        this.api.DeleteProjects(id).subscribe((res) => {
          if (res.status === "1") {
            this.config.ToastrSuccess(res.message);
            this.GetProject();
          } else {
            this.config.ToastrError(res.message);
          }
        });
      }
    });
  }
}
